import React, { useState } from "react";
import { BankAccountForm } from "@/dentlab/src/forms/form-components/bank-account/insert-update/bank-account.form";
import { BankAccountList } from "@/dentlab/src/components/list-components/bank-account-list.component";
import { Button } from "@/dentlab/src/components/ui/button";
import { ArrowLeft } from "lucide-react";

type ViewMode = 'list' | 'new' | 'edit';

export const KontenAdminPage: React.FC = () => {
	const [viewMode, setViewMode] = useState<ViewMode>('list');
	const [bankAccountId, setBankAccountId] = useState<number | undefined>(
		undefined
	);

	const handleEdit = (accountId: string) => {
		setBankAccountId(Number(accountId));
		setViewMode('edit');
	};

	const handleSave = () => {
		setViewMode('list');
		setBankAccountId(undefined);
	};

	const handleBack = () => {
		setViewMode('list');
		setBankAccountId(undefined);
	};

	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<div className="flex items-center gap-4 mb-6">
					{viewMode !== 'list' && (
						<Button
							variant="ghost"
							size="icon"
							onClick={handleBack}
							className="h-8 w-8"
						>
							<ArrowLeft className="h-4 w-4" />
						</Button>
					)}
					<h1 className="text-2xl font-semibold text-gray-900">
						{viewMode === 'list' && 'Konten'}
						{viewMode === 'new' && 'Neues Konto'}
						{viewMode === 'edit' && 'Konto bearbeiten'}
					</h1>
				</div>

				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
					{viewMode === 'list' && (
						<>
							<div className="mb-4">
								<Button onClick={() => setViewMode('new')}>
									Neues Konto
								</Button>
							</div>
							<BankAccountList onEdit={handleEdit} />
						</>
					)}

					{viewMode === 'new' && (
						<BankAccountForm
							onSave={handleSave}
						/>
					)}

					{viewMode === 'edit' && bankAccountId && (
						<BankAccountForm
							bankAccountId={bankAccountId.toString()}
							onSave={handleSave}
						/>
					)}
				</div>
			</div>
		</div>
	);
};